import { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';
import { useMsal } from '@azure/msal-react';

import { emptyLocal, getLocal, resetProfile, setLocal } from '../../utils/api';

import './Menu.css';

function Menu({ handleFeedback, toggleMenu }) {
  const { logout } = useAuth0();
  const { instance } = useMsal();
  const location = useLocation();
  const navigate = useNavigate();

  const [profile, ] = useState(getLocal('profile'));
  const [userDescription, setUserDescription] = useState(null);
  const [userName, setUserName] = useState(null);

  const handleLogout = useCallback(async () => {
    const tenant = getLocal('tenant');

    if (tenant) {
      if (tenant.idpType === 'saml') {
        const account = instance.getActiveAccount() || instance.getAllAccounts()[0];

        if (account) {
          await instance.clearCache({ account });
        }

        emptyLocal();

        if (tenant.slug) {
          setLocal('logout', tenant.slug);
          window.location = '/';
        }
      } else {
        if (tenant.slug) {
          setLocal('logout', tenant.slug);
        }

        logout({ logoutParams: { returnTo: window.location.origin } });
      }

      if (!tenant.slug) {
        await resetProfile();
      }
    }
  }, [instance, logout]);

  const handleProfile = useCallback(() => {
    navigate('/profile', { state: { from: location.pathname }});
  }, [location, navigate]);

  useEffect(() => {
    if (profile?.meta_data) {
      const name = profile.meta_data.find(item => item.param === 'name');

      if (name?.value) {
        setUserName(name.value);
      } else {
        const firstName = profile.meta_data.find(item => item.param === 'first_name');
        setUserName(firstName?.value);
      }

      const location = profile.meta_data.find(item => item.param === 'location');
      setUserDescription(location?.value);
    }
  }, [profile]);

  return (
    <>
      <div id="overlay"></div>
      <div id="menu">
        <div className="close" onClick={toggleMenu}></div>
        <div className="user">
          <div className="avatar" onClick={handleProfile}>{userName?.substr(0, 1)}</div>
          <div className="user-info">
            <div className="user-name">{userName}</div>
            <div className="user-description">{userDescription}</div>
          </div>
        </div>
        <div className="scrollable overflow">
          {/*
          <div className="item bookmarks">
            <div className="icon"></div>
            <div className="label">
              <div className="label-title">Saved Resources</div>
              <div className="label-description">View Your Bookmarks</div>
            </div>
          </div>
          */}
          <div className="item feedback" onClick={handleFeedback}>
            <div className="icon"></div>
            <div className="label">
              <div className="label-title">Feedback</div>
              <div className="label-description">Share Your Thoughts</div>
            </div>
          </div>
          {/*
          <div className="item help">
            <div className="icon"></div>
            <div className="label">
              <div className="label-title">Help</div>
              <div className="label-description">Support and Guidance</div>
            </div>
          </div>
          <div className="item settings">
            <div className="icon"></div>
            <div className="label">
              <div className="label-title">Settings</div>
              <div className="label-description">Manage Your Preferences</div>
            </div>
          </div>
          */}
        </div>
        <div className="logout" onClick={handleLogout}>
          <div className="icon"></div>
          <div className="label">Logout</div>
          <div className="arrow"></div>
        </div>
      </div>
    </>
  );
}

export default Menu;
